export interface DashboardAddContentFiltersModels {
    dashboardContentId: number;
    filterType: typeDashboardAvailableFilters;
    filterValue: string;
    statusId: number;
}

export interface UpdateDashboardContentFiltersModels extends DashboardAddContentFiltersModels {
    id: number;
}

export interface DashboardContentFilterDetailsModels extends DashboardAddContentFiltersModels {
    id: number;
}

export const DashboardAvailableFilterTypes = {
    DateFilter: 'DateFilter',
    CustomDateFilterJSON: 'CustomDateFilterJSON',
    AccountChannelId: 'AccountChannelId',
    LeadChannelId: 'LeadChannelId',
    OpportunityChannelId: 'OpportunityChannelId',
    TerritoryChannelId: 'TerritoryChannelId',
    SelectedTerritoryId: 'SelectedTerritoryId',
    SummaryWidgetCode: 'SummaryWidgetCode',
    SummaryWidgetTitle: 'SummaryWidgetTitle',
    SummaryWidgetTheme: 'SummaryWidgetTheme',
    CountFormat: 'CountFormat',
    FilterRange: 'FilterRange',
    SavedSearchId: 'SavedSearchId',
    SavedSearchBotQuery: 'SavedSearchBotQuery',
    SavedSearchChartTitle: 'SavedSearchChartTitle',
    WorkbookDynamicChart: 'WorkbookDynamicChart',
    WorkbookDynamicChartFilters: 'WorkbookDynamicChartFilters'
} as const;
export type typeDashboardAvailableFilters = keyof typeof DashboardAvailableFilterTypes;
